<template>
  <v-dialog v-model="dialog" :max-width="500" persistent>
    <v-card>
      <v-toolbar dark :color="titleColor" dense>
        <v-icon left v-if="dirty">mdi-alert</v-icon>
        <v-toolbar-title class="white--text">Session timeout</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">
        <span>Your session is about to expire. </span>
        <span v-if="dirty"><strong>Your unsaved changes will be discarded when the session expires. </strong></span>
        <span>You will be automatically signed out in {{ secondsLeft }} seconds.</span><br />
        <br />
        <span>Do you want to extend this session?</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="extend">Stay signed in</v-btn>
        <v-btn text @click="signout">Sign me out</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { DateTime } from 'luxon'

export default {
  name: 'SessionTimeoutDialog',
  data() {
    return {
      dialog: false,
      resolve: null,
      secondsLeft: null,
      timer: null,
      dirty: false
    }
  },
  computed: {
    ...mapState({
      sessionExpiration: state => state.sessionExpiration
    }),
    expirationDateTime() {
      return DateTime.fromISO(this.sessionExpiration, { zone: 'utc' })
    },
    titleColor() {
      return this.dirty ? 'warning' : 'info'
    }
  },
  methods: {
    show(options) {
      this.$store.dispatch('sessionTimeoutShown')

      this.dirty = options ? !!options.dirty : false
      this.setSecondsLeft()

      this.timer = setInterval(() => {
        this.setSecondsLeft()
        if (this.secondsLeft <= 0) {
          this.timeout()
        }
      }, 1000)

      this.dialog = true

      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    setSecondsLeft() {
      let diff = Math.trunc(this.expirationDateTime.diffNow().as('seconds'))
      this.secondsLeft = !this.expirationDateTime || isNaN(diff) ? 0 : diff
    },
    extend() {
      this.dialog = false
      this.resolve('extend')
      this.clear()
    },
    signout() {
      this.dialog = false
      this.resolve('signout')
      this.clear()
    },
    timeout() {
      this.dialog = false
      this.resolve('timeout')
      this.clear()
    },
    clear() {
      clearInterval(this.timer)
      this.secondsLeft = null
    }
  }
}
</script>
